export const info = {
    "managers": [
      {
        firstName: "Nora",
        lastName: "Georgieva",
        position: "Lead Investor"
      }, {
        firstName: "Carl",
        lastName: "Bergenhem",
        position: "Advisor"
      }, {
        firstName: "Kiril",
        lastName: "Peyanski",
        position: "Senior Analyst"
      }, {
        firstName: "Pamela",
        lastName: "Petkova",
        position: "Senior Analyst"
      }, {
        firstName: "Vasil",
        lastName: "Raev",
        position: "Junior Associate"
      }, {
        firstName: "Genady",
        lastName: "Sergeev",
        position: "Trainee"
      }
    ],
    "quarters": [
      {
        title: "Q1 2020",
        details: [
          { name: "Expense Ratio", value: "0.13%" },
          { name: "Minimum Investment", value: "$0.00" },
          { name: "Turnover Rate", value: "11%" },
          { name: "Portfolio Assets", value: "$5,533M" },
          { name: "12-Month Low", value: "$35.45" },
          { name: "12-Month High", value: "$50.59" }
        ]
      },
      {
        title: "Q4 2019",
        details: [
          { name: "Expense Ratio", value: "0.13%" },
          { name: "Minimum Investment", value: "$0.00" },
          { name: "Turnover Rate", value: "11%" },
          { name: "Portfolio Assets", value: "$5,533M" },
          { name: "12-Month Low", value: "$35.45" },
          { name: "12-Month High", value: "$50.59" }
        ]
      },
      {
        title: "Q3 2019",
        details: [
          { name: "Expense Ratio", value: "0.13%" },
          { name: "Minimum Investment", value: "$0.00" },
          { name: "Turnover Rate", value: "11%" },
          { name: "Portfolio Assets", value: "$5,533M" },
          { name: "12-Month Low", value: "$35.45" },
          { name: "12-Month High", value: "$50.59" }
        ]
      },
      {
        title: "Q2 2019",
        details: [
          { name: "Expense Ratio", value: "0.13%" },
          { name: "Minimum Investment", value: "$0.00" },
          { name: "Turnover Rate", value: "11%" },
          { name: "Portfolio Assets", value: "$5,533M" },
          { name: "12-Month Low", value: "$35.45" },
          { name: "12-Month High", value: "$50.59" }
        ]
      },
      {
        title: "Q1 2019",
        details: [
          { name: "Expense Ratio", value: "0.13%" },
          { name: "Minimum Investment", value: "$0.00" },
          { name: "Turnover Rate", value: "11%" },
          { name: "Portfolio Assets", value: "$5,533M" },
          { name: "12-Month Low", value: "$35.45" },
          { name: "12-Month High", value: "$50.59" }
        ]
      },
      {
        title: "Q4 2018",
        details: [
          { name: "Expense Ratio", value: "0.13%" },
          { name: "Minimum Investment", value: "$0.00" },
          { name: "Turnover Rate", value: "11%" },
          { name: "Portfolio Assets", value: "$5,533M" },
          { name: "12-Month Low", value: "$35.45" },
          { name: "12-Month High", value: "$50.59" }
        ]
      },
      {
        title: "Q3 2018",
        details: [
          { name: "Expense Ratio", value: "0.13%" },
          { name: "Minimum Investment", value: "$0.00" },
          { name: "Turnover Rate", value: "11%" },
          { name: "Portfolio Assets", value: "$5,533M" },
          { name: "12-Month Low", value: "$35.45" },
          { name: "12-Month High", value: "$50.59" }
        ]
      },
      {
        title: "Q2 2018",
        details: [
          { name: "Expense Ratio", value: "0.13%" },
          { name: "Minimum Investment", value: "$0.00" },
          { name: "Turnover Rate", value: "11%" },
          { name: "Portfolio Assets", value: "$5,533M" },
          { name: "12-Month Low", value: "$35.45" },
          { name: "12-Month High", value: "$50.59" }
        ]
      }
    ]
  }